//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
SPLM.BaseSession = class extends SPLM.Object {
    constructor( creator){
        super(creator);
        this._d['Class'] = "SPLM.BaseSession";
    }
    get Class(){return this._d['Class'];}
    set Class(v){this._d['Class'] = v;}
};

export default SPLM;